import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";
import { Tooltip, TooltipHeader, TooltipBody } from "ComponentsUI/Tooltip";
import { svgPathDodyList } from "Constants/SVG";

const styles = theme => ({
    root: {
        width: "100%",
    },
    wrapper: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        justifyContent: "center",
    },
    svgItem: {
        width: "24px",
        height: "24px",
        fill: theme.palette.colors.purplishBlue,
        "& .cls-1": {
            fill: theme.palette.colors.purplishBlue,
        },
    },
    svgTV: {
        marginTop: "5px",
    },
    itemNotExist: {
        "& svg": {
            fill: theme.palette.colors.cloudyBlue,
            "& .cls-1": {
                fill: theme.palette.colors.cloudyBlue,
            },
        },
    },
    itemYetInclude: {
        "& svg": {
            fill: "#23c4a0",
            "& .cls-1": {
                fill: "#23c4a0",
            },
        },
    },
    itemMayBeInclude: {
        "& svg": {
            fill: theme.palette.colors.purplishBlue,
            "& .cls-1": {
                fill: theme.palette.colors.purplishBlue,
            },
        },
    },
    itemWrapper: {
        marginRight: "5px",
        marginLeft: "5px",
        marginBottom: "5px",
        display: "block",
    },
    [`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
        wrapper: {
            justifyContent: "flex-start",
        },
    },
    [`@media (max-width: ${theme.media.sm})`]: {
        wrapper: {
            justifyContent: "center",
        },
        svgItem: {
            width: "20px",
            height: "20px",
        },
        itemWrapper: {
            marginRight: "4px",
            marginLeft: "4px",
            marginBottom: "0",
            display: "block",
        },
    },
});

class DodysList extends React.Component {
    generateDodysWrapper() {
        const { items, classes } = this.props;

        if (items) {
            return (
                <div className={classNames(classes.wrapper)}>
                    {this.renderDodyList(items)}
                </div>
            );
        } else {
            return null;
        }
    }

    preventBehavior(e) {
        e.stopPropagation();
    }

    renderDodyList(items) {
        let classes = this.props.classes;
        return items.map((item, index) => {
            let textTooltip = item.short_description || "";
            textTooltip = (
                <div dangerouslySetInnerHTML={{ __html: textTooltip }} />
            );
            return (
                <div
                    key={index}
                    className={classNames(classes.item, {
                        [classes.itemNotExist]: !item.state,
                        [classes.itemYetInclude]: item.state === 1,
                        [classes.itemMayBeInclude]: item.state === 2,
                    })}
                >
                    <Tooltip
                        header={<TooltipHeader text={item.name} />}
                        body={<TooltipBody>{textTooltip}</TooltipBody>}
                    >
                        <div className={classes.itemWrapper}>
                            <svg
                                width="24px"
                                height="20px"
                                viewBox="0 0 24 24"
                                preserveAspectRatio="xMidYMid meet"
                                className={classNames(classes.svgItem, {
                                    [classes.svgTV]: index === 1,
                                })}
                            >
                                <path d={svgPathDodyList[index]} />
                            </svg>
                        </div>
                    </Tooltip>
                </div>
            );
        });
    }

    render() {
        const { classes } = this.props;

        return (
            <div
                className={classes.root}
                onClick={e => this.preventBehavior(e)}
            >
                {this.generateDodysWrapper()}
            </div>
        );
    }
}

export default withStyles(styles)(DodysList);
